// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__179NY","col":"styles_col__39vTB"};